import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Money from './types/Money';
import Reference from './types/Reference';

export default class BN_AuthRegisterLedgerItem extends BackboneElement {
    static __className = 'BN_AuthRegisterLedgerItem';

    __objectStructure = {
        date: Date,
        amount: Money,
        unit: Number,
        chargeItem: Reference,
    };

    constructor(constructJson, className = 'BN_AuthRegisterLedgerItem') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
